module.exports = __webpack_public_path__ + "img/chronopay.f2e4800b.png";